import lotteriesEnum from '../Global/lotteries';

export default lotteriesEnum();
